import React from 'react';

import clsx from 'clsx';

import { getIconSrc } from './iconHelper';
import IconsEnum from './IconsEnum';
import css from './style.module.less';

export interface IPohIconProps {
  name: IconsEnum;
  src?: string;
  alt?: string;
  className?: string;
  style?: React.CSSProperties;
}

const PohIcon: React.FC<IPohIconProps> = ({ name, src, style = {}, className, ...rest }) => {
  const iconStyle: React.CSSProperties = {
    width: '1em',
    minWidth: '1em',
    height: '1em',
    minHeight: '1em',
    ...style,
  };

  const Component = name && getIconSrc(name);
  return name ? (
    <Component
      style={iconStyle}
      alt={rest.alt || name || 'icon'}
      className={clsx(css.icon, className)}
      {...rest}
    />
  ) : (
    <img
      src={src}
      style={iconStyle}
      alt={rest.alt || name || 'icon'}
      className={clsx(css.icon, className)}
      {...rest}
    />
  );
};

export default PohIcon;
